import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { DollarSign, ShoppingCart, TrendingUp, TrendingDown } from 'react-feather';

function KPICards({ totals }) {
    const fmt = (n) => (n < 0 ? '-' : '') + '$' + Math.abs(Math.round(n)).toLocaleString();
    const pct = (n) => n.toFixed(1) + '%';
    console.log('KPICards totals:', totals);
    const gpColor = totals.gp >= 0 ? '#28a745' : '#dc3545';
    const gpBg = totals.gp >= 0 ? '#f0f8f5' : '#ffe5eb';
    const pctColor = totals.pct >= 0 ? '#28a745' : '#dc3545';
    const pctBg = totals.pct >= 0 ? '#f0f8f5' : '#ffe5eb';
    const kpiData = [
        {
            label: 'Revenue (inc GST)',
            value: fmt(totals.revenueIncGST || 0),
            icon: DollarSign,
            color: '#17a2b8',
            bgColor: '#e0f7fa',
            valueColor: '#333'
        },
        {
            label: 'Revenue (ex GST)',
            value: fmt(totals.revenue),
            icon: DollarSign,
            color: '#007bff',
            bgColor: '#e7f1ff',
            valueColor: '#333'
        },
        {
            label: 'COGS (inc GST)',
            value: fmt(totals.cogsIncGST || 0),
            icon: ShoppingCart,
            color: '#e67e22',
            bgColor: '#fdebd0',
            valueColor: '#333'
        },
        {
            label: 'COGS (ex GST)',
            value: fmt(totals.cogs),
            icon: ShoppingCart,
            color: '#ff9f43',
            bgColor: '#fff5eb',
            valueColor: '#333'
        },
        {
            label: 'Gross profit',
            value: fmt(totals.gp),
            icon: totals.gp >= 0 ? TrendingUp : TrendingDown,
            color: gpColor,
            bgColor: gpBg,
            valueColor: gpColor
        },
        {
            label: 'GP %',
            value: pct(totals.pct),
            icon: totals.pct >= 0 ? TrendingUp : TrendingDown,
            color: pctColor,
            bgColor: pctBg,
            valueColor: pctColor
        }
    ];

    return (
        <div className="gp-cards-scroll-wrapper mt-4">
            {kpiData.map((kpi, idx) => {
                const Icon = kpi.icon;
                return (
                    <div className="gp-card-scroll-item" key={idx}>
                        <Card className="gp-card-item h-100">
                            <CardBody>
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="flex-grow-1">
                                        <p className="gp-card-lbl">{kpi.label}</p>
                                        <h3 className="gp-card-val" style={{ color: kpi.valueColor }}>{kpi.value}</h3>
                                    </div>
                                    <div
                                        className="gp-card-icon"
                                        style={{
                                            backgroundColor: kpi.bgColor,
                                            color: kpi.color
                                        }}
                                    >
                                        <Icon size={20} />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                );
            })}
        </div>
    );
}

export default KPICards;
